module.exports = __webpack_public_path__ + "img/carousel-vet-5.154ae687.jpg";